"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getTagPositions = (text) => {
    const lines = text.split('\n');
    const re = /\{\{.+?\}\}/g;
    const positions = [];
    let m;
    for (let i = 0; i < lines.length; i++) {
        while ((m = re.exec(lines[i])) !== null) {
            const tag = m[0].substring(2, m[0].length - 2);
            positions.push({
                line: i,
                start: m.index,
                stop: m.index + m[0].length,
                tag,
            });
        }
    }
    return positions;
};
exports.default = getTagPositions;
